import api from './axiosInstance';

export const getStockApi        = ()       => api.get('/stock');
export const createStockApi     = (data)   => api.post('/stock', data);
export const addStockApi        = (data)   => api.post('/stock/add', data);
export const consumeStockApi    = (data)   => api.post('/stock/use', data);
export const getStockLogsApi    = (params) => api.get('/stock/logs', { params });
